import { handleActions, combineActions } from 'redux-actions'
import { Map } from 'immutable'
import * as actions from './actions'

export const teams = handleActions(
  {
    [actions.fetchOrgTeamsSuccess]: (state, action) => {
      return state.set('data', action.payload)
    },

    [actions.patchOrgTeamSuccess]: (state, action) => {
      const { teamId, team } = action.payload
      const restTeams = state.get('data').filter(team => team.id !== teamId)
      return state.set('data', [...restTeams, team])
    },

    [actions.deleteOrgTeam]: (state, { payload }) => {
      return state.set('data', state.get('data').filter(team => team.id !== payload.teamId))
    },

    [actions.fetchTeamAvailabilitiesSuccess]: (state, action) => {
      return state.set('teamAvailabilities', action.payload)
    },

    [actions.updateAvailabilityForTeamSuccess]: (state, action) => {
      const { teamAvailabilitySettings } = action.payload
      const restAvailabilities = state
        .get('teamAvailabilities')
        .filter(ta => ta.id !== teamAvailabilitySettings.id)
      return state.set('teamAvailabilities', [...restAvailabilities, teamAvailabilitySettings])
    },

    [combineActions(
      actions.fetchOrgTeamsFailed,
      actions.fetchOrgTeamsPending,
      actions.fetchOrgTeamsSuccess
    )]: (state, action) => {
      return state.setIn(['status', 'fetch'], action.type)
    },

    [combineActions(
      actions.createOrgTeamFailed,
      actions.createOrgTeamPending,
      actions.createOrgTeamSuccess
    )]: (state, action) => {
      return state.setIn(['status', 'create'], action.type)
    },

    [combineActions(actions.patchOrgTeamFailed, actions.patchOrgTeamPending, actions.patchOrgTeamSuccess)]: (
      state,
      action
    ) => {
      return state.setIn(['status', 'update'], action.type)
    },

    [combineActions(
      actions.deleteOrgTeamFailed,
      actions.deleteOrgTeamPending,
      actions.deleteOrgTeamSuccess
    )]: (state, action) => {
      return state.setIn(['status', 'delete'], action.type)
    },

    [combineActions(
      actions.updateAvailabilityForTeamFailed,
      actions.updateAvailabilityForTeamPending,
      actions.updateAvailabilityForTeamSuccess
    )]: (state, action) => {
      return state.setIn(['status', 'updateAvailabilityForTeam'], action.type)
    },

    [combineActions(
      actions.fetchTeamAvailabilitiesFailed,
      actions.fetchTeamAvailabilitiesPending,
      actions.fetchTeamAvailabilitiesSuccess
    )]: (state, action) => {
      return state.setIn(['status', 'fetchAllAvailabilities'], action.type)
    },

    [combineActions(
      actions.fetchTeamAvailabilityFailed,
      actions.fetchTeamAvailabilityPending,
      actions.fetchTeamAvailabilitySuccess
    )]: (state, action) => {
      return state.setIn(['status', 'fetchSingleAvailability'], action.type)
    },

    [combineActions(
      actions.createTeamAvailabilityFailed,
      actions.createTeamAvailabilityPending,
      actions.createTeamAvailabilitySuccess
    )]: (state, action) => {
      return state.setIn(['status', 'createTeamAvailability'], action.type)
    },

    [combineActions(
      actions.updateTeamAvailabilityFailed,
      actions.updateTeamAvailabilityPending,
      actions.updateTeamAvailabilitySuccess
    )]: (state, action) => {
      return state.setIn(['status', 'updateTeamAvailability'], action.type)
    },
  },
  Map()
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/teams/reducer.js